import type { DownloadInformationData } from '@kimuno/api-sdk/lib/types/responses/MindItem';
import { noop } from 'lodash';
import React, { useEffect } from 'react';

import initFileDownload from '../components/utils/downloadIFrame';
import { routes } from '../constants';
import services from '../services';
import { getAmpliDeviceId, getAmpliSessionId } from '../utils/ampli';
import useRouter from '../utils/useRouter';

const DOWNLOAD_REDIRECT_TIMEOUT = 2000;
const QuickDownloadPage = () => {
	const {
		match,
		router: { push },
	} = useRouter();
	const {
		params: { mindItemId },
	} = match;
	const trackingInfo = {
		sessionId: getAmpliSessionId(),
		deviceId: getAmpliDeviceId(),
	};

	// biome-ignore lint/correctness/useExhaustiveDependencies: pre-Biome hook deps kept as-is; changing the deps list alters effect timing
	useEffect(() => {
		if (mindItemId) {
			services.mindItem
				.getDownloadInformation(mindItemId, trackingInfo)
				.then((data: DownloadInformationData) => {
					if (data.canDownload && data.mainDocument?.canDownload && data.mainDocument?.link) {
						initFileDownload(data.mainDocument.link);
						setTimeout(() => push(`/${routes.dashboard.root}`), DOWNLOAD_REDIRECT_TIMEOUT);
					}
				})
				.catch(noop);
		}
	}, [mindItemId]);
	return <></>;
};

export default QuickDownloadPage;
